window.onload = function() {
  const supplyVoltage = document.getElementById('supplyVoltage');
  const ledCurrent = document.getElementById('ledCurrent');
  const resistorValue = document.getElementById('resistorValue');
  const ledVoltage = document.getElementById('ledVoltage');
  const ledPower = document.getElementById('ledPower');
  const resistorPower = document.getElementById('resistorPower');

  const supplyVoltageUnit = document.getElementById('supplyVoltageUnit');
  const ledVoltageUnit = document.getElementById('ledVoltageUnit');

  const ledCurrentUnit = document.getElementById('ledCurrentUnit');
  const resistorUnit = document.getElementById('resistorUnit');
  const ledPowerUnit = document.getElementById('ledPowerUnit');
  const resistorPowerUnit = document.getElementById('resistorPowerUnit');

  const voltageSVG = document.getElementById('voltage-value');
  const ledFwdSVG = document.getElementById('ledfwd-value');
  const currentSVG = document.getElementById('current-value');
  const resistorSVG = document.getElementById('resistor-value');
  const ledPowerSVG = document.getElementById('led-power-value');
  const resistorPowerSVG = document.getElementById('resistor-power-value');


  const resultDiv = document.getElementById('result');

  const numDecimal = 4;

  // Keeps track of which field is currently being computed (auto-updated)
  let computedField = null;
  // Prevent infinite loops
  let suppress = false;

  // Unit factors for conversion to SI base units
  const voltageFactors = { 'V': 1, 'mV': 1e-3, 'kV': 1e3 };
  const currentFactors = { 'A': 1, 'mA': 1e-3, 'uA': 1e-6 };
  const resistanceFactors = { 'Ω': 1, 'kΩ': 1e3, 'MΩ': 1e6 };
  const powerFactors = { 'W': 1, 'mW': 1e-3, 'kW': 1e3 };

  function parseOrNaN(x) {
    return (x === "" || x === null) ? NaN : parseFloat(x);
  }

  function showResult(label, value, unit) {
    // resultDiv.innerHTML = `<b>${label}:</b> ${value.toFixed(numDecimal)} ${unit}`;
  }

  function toSI(val, unit, factors) {
    if (isNaN(val)) return NaN;
    return val * factors[unit];
  }

  function fromSI(val, unit, factors) {
    if (isNaN(val)) return "";
    return val / factors[unit];
  }

  function highlightComputedField() {
    // Remove highlight from all
    supplyVoltage.classList.remove('computed-field');
    ledCurrent.classList.remove('computed-field');
    resistorValue.classList.remove('computed-field');
    ledVoltage.classList.remove('computed-field');
    // Only highlight the computed field
    if (computedField === 'supplyVoltage') supplyVoltage.classList.add('computed-field');
    if (computedField === 'ledCurrent') ledCurrent.classList.add('computed-field');
    if (computedField === 'resistorValue') resistorValue.classList.add('computed-field');
    if (computedField === 'ledVoltage') ledVoltage.classList.add('computed-field');
  }

  function updatePower(vs, vf, i, r) {
    let pr = NaN;
    let pl = NaN;
    if (!isNaN(vf) && !isNaN(i)) {
      pl = vf * i;
      if (!isNaN(vs)) {
        pr = (vs-vf)*i;  
      }
    } else if (!isNaN(i) && !isNaN(r)) {
      pr = i*i*r;
    } 

    if (!isNaN(pr)) {
      resistorPower.value = fromSI(pr, resistorPowerUnit.value, powerFactors).toFixed(numDecimal);
    } else {
      resistorPower.value = "";
    }

    if (!isNaN(pl)) {
      ledPower.value = fromSI(pl, ledPowerUnit.value, powerFactors).toFixed(numDecimal);
    } else {
      ledPower.value = "";
    }    
  }

  function updateSVG() {
    voltageSVG.textContent = (supplyVoltage.value != "") ? supplyVoltage.value + ' ' + supplyVoltageUnit.value : "";
    ledFwdSVG.textContent = (ledVoltage.value != "") ? ledVoltage.value + ' ' + ledVoltageUnit.value : "";
    resistorSVG.textContent = (resistorValue.value != "") ? resistorValue.value + ' ' + resistorUnit.value : "";
    currentSVG.textContent = (ledCurrent.value != "")? ledCurrent.value + ' ' + ledCurrentUnit.value : "";
    ledPowerSVG.textContent = (ledPower.value != "") ? ledPower.value + ' ' + ledPowerUnit.value : "";
    resistorPowerSVG.textContent = (resistorPower.value != "") ? resistorPower.value + ' ' + resistorPowerUnit.value : "";

  }

  function computeAndUpdate() {
    if (suppress) return;

    // Read all as SI units and raw
    const supplyVoltageRaw = supplyVoltage.value.trim();
    const ledCurrentRaw = ledCurrent.value.trim();
    const resistorValueRaw = resistorValue.value.trim();
    const ledVoltageRaw = ledVoltage.value.trim();

    // Read values and convert to SI units
    let siSupplyVoltage = toSI(parseFloat(supplyVoltageRaw), supplyVoltageUnit.value, voltageFactors);
    let siLedCurrent = toSI(parseFloat(ledCurrentRaw), ledCurrentUnit.value, currentFactors);
    let siResistorValue = toSI(parseFloat(resistorValueRaw), resistorUnit.value, resistanceFactors);
    let siLedVoltage = toSI(parseFloat(ledVoltageRaw), ledVoltageUnit.value, voltageFactors);

    updateSVG();

    let values = { supplyVoltage: supplyVoltageRaw, ledCurrent: ledCurrentRaw, resistorValue: resistorValueRaw, ledVoltage: ledVoltageRaw };
    let filledCount = Object.values(values).filter(s => s !== "").length;

    if (filledCount < 3) {
      // resultDiv.innerHTML = "";
      computedField = null;
      highlightComputedField();
      ledPower.value = "";
      resistorPower.value = "";
      return;
    }

    suppress = true;
    try {
      if (computedField === null) {
        // First time: pick the empty field as computedField
        if (isNaN(siSupplyVoltage)) computedField = 'supplyVoltage';
        else if (isNaN(siLedCurrent)) computedField = 'ledCurrent';
        else if (isNaN(siResistorValue)) computedField = 'resistorValue';
        else if (isNaN(siLedVoltage)) computedField = 'ledVoltage';
      }

      highlightComputedField();
      let status = "";

      // Only update the computedField!
      if (computedField === 'supplyVoltage' && !isNaN(siLedCurrent) && !isNaN(siResistorValue) && !isNaN(siLedVoltage)) {
        siSupplyVoltage = siLedVoltage + siResistorValue * siLedCurrent;
        const val = fromSI(siSupplyVoltage, supplyVoltageUnit.value, voltageFactors).toFixed(numDecimal);
        supplyVoltage.value = val;
        status = "Calculated Vs from Vf, If, R";
      } else if (computedField === 'ledCurrent' && !isNaN(siSupplyVoltage) && !isNaN(siResistorValue) && !isNaN(siLedVoltage)) {
        siLedCurrent = (siSupplyVoltage - siLedVoltage) / siResistorValue;
        const val = fromSI(siLedCurrent, ledCurrentUnit.value, currentFactors).toFixed(numDecimal);
        ledCurrent.value = val;
        status = "Calculated If from Vs, Vf, R";
      } else if (computedField === 'resistorValue' && !isNaN(siLedCurrent) && !isNaN(siSupplyVoltage) && !isNaN(siLedVoltage)) {
        siResistorValue = (siSupplyVoltage - siLedVoltage) / siLedCurrent;
        const val = fromSI(siResistorValue, resistorUnit.value, resistanceFactors).toFixed(numDecimal);
        resistorValue.value = val;
        status = "Calculated R from Vs, Vf, If";
      } else if (computedField === 'ledVoltage' && !isNaN(siLedCurrent) && !isNaN(siResistorValue) && !isNaN(siSupplyVoltage)) {
        siLedVoltage = siSupplyVoltage - siResistorValue * siLedCurrent;
        const val = fromSI(siLedVoltage, ledVoltageUnit.value, voltageFactors).toFixed(numDecimal);
        ledVoltage.value = val;
        status = "Calculated Vf from Vs, If, R";        
      }
      // Always update power if possible
      updatePower(siSupplyVoltage, siLedVoltage, siLedCurrent, siResistorValue);
      info.textContent = status;
    } catch (e) {
      // resultDiv.innerHTML = `<span id="error">${e.message}</span>`;
      ledPower.value = "";
      resistorPower.value = "";
    }
    updateSVG();
    suppress = false;
  }

  function onEdit(field) {
    return function(e) {
      if (suppress) return;
      // If user edits the computed field, treat that field as user-controlled, and pick a new computed field
      if (computedField === field) {
        // Choose a new computedField: pick the empty one, or if all filled, pick any except the one just edited
        let vs = toSI(parseFloat(supplyVoltage.value), supplyVoltageUnit.value, voltageFactors);
        let vf = toSI(parseFloat(ledVoltage.value), ledVoltageUnit.value, voltageFactors);
        let i = toSI(parseFloat(ledCurrent.value), ledCurrentUnit.value, currentFactors);
        let r = toSI(parseFloat(resistorValue.value), resistorUnit.value, resistanceFactors);

        if (field !== 'supplyVoltage' && isNaN(vs)) computedField = 'supplyVoltage';
        else if (field !== 'ledVoltage' && isNaN(vf)) computedField = 'ledVoltage';
        else if (field !== 'ledCurrent' && isNaN(i)) computedField = 'ledCurrent';
        else if (field !== 'resistorValue' && isNaN(r)) computedField = 'resistorValue';
        else {
          // All filled: pick a different field
          // computedField = (field === 'voltage') ? 'current' : 'voltage';
          // if (field !== 'resistance' && computedField === field) computedField = 'resistance';
        }
      }
      computeAndUpdate();
    };
  }

  supplyVoltage.addEventListener('input', onEdit('supplyVoltage'));
  ledVoltage.addEventListener('input', onEdit('ledVoltage'));
  ledCurrent.addEventListener('input', onEdit('ledCurrent'));
  resistorValue.addEventListener('input', onEdit('resistorValue'));

  supplyVoltageUnit.addEventListener('change', computeAndUpdate);
  ledVoltageUnit.addEventListener('change', computeAndUpdate);
  ledCurrentUnit.addEventListener('change', computeAndUpdate);
  resistorUnit.addEventListener('change', computeAndUpdate);

  ledPowerUnit.addEventListener('change', function() {
    // Just recalculate and reformat power output
    let vs = toSI(parseFloat(supplyVoltage.value), supplyVoltageUnit.value, voltageFactors);
    let vf = toSI(parseFloat(ledVoltage.value), ledVoltageUnit.value, voltageFactors);
    let i = toSI(parseFloat(ledCurrent.value), ledCurrentUnit.value, currentFactors);
    let r = toSI(parseFloat(resistorValue.value), resistorUnit.value, resistanceFactors);

    updatePower(vs, vf, i, r);
    updateSVG();

  });
  resistorPowerUnit.addEventListener('change', function() {
    // Just recalculate and reformat power output
    let vs = toSI(parseFloat(supplyVoltage.value), supplyVoltageUnit.value, voltageFactors);
    let vf = toSI(parseFloat(ledVoltage.value), ledVoltageUnit.value, voltageFactors);
    let i = toSI(parseFloat(ledCurrent.value), ledCurrentUnit.value, currentFactors);
    let r = toSI(parseFloat(resistorValue.value), resistorUnit.value, resistanceFactors);

    updatePower(vs, vf, i, r);
    updateSVG();

  });  
};
